<script setup lang="ts">
import { FontAwesomeIcon } from '@sunlabde/m2m-library';
import { useLocalization } from '@/models/Localization';
import type { QuoteItem } from '@/models/Quote';

defineProps<{
	quote: QuoteItem;
}>();

const { localize } = useLocalization();
</script>

<template>
	<div class="px-6 py-5 bg-white flex gap-6 rounded-2xl relative overflow-hidden">
		<FontAwesomeIcon
			:icon="['fas', 'quote-right']"
			class="text-secondary-500/50 h-16 w-16 absolute -top-4 -right-1"
		/>
		<img
			:src="quote.image.src"
			:alt="$t('aside.quote.image.alt', {name: localize(quote.title) })"
			class="w-24 h-24 rounded-full"
		>
		<div class="text-black">
			<p class="font-bold text-xl mb-1">
				{{ localize(quote.title) }}
			</p>
			<p class="text-xs">
				{{ localize(quote.quote) }}
			</p>
		</div>
	</div>
</template>
